



































import { Component, Vue, Prop } from 'vue-property-decorator';

import { program } from '@/store/fifth/store';
import Session from '@/components/Fifth/program/Session.vue';

@Component({
  components: {
    Session
  }
})
export default class Program extends Vue {
  private program = program;
}
